/**
 * Bundled environment variable resolver.
 *
 * esbuild's `define` only replaces **static** references like
 * `process.env.RAINDROP_API_KEY`. Dynamic lookups such as
 * `process.env[varName]` are left untouched, which means the bundled
 * values are never injected in production builds.
 *
 * This module maps each known bundled env var name to its static
 * reference so esbuild can substitute the value at build time.
 */

const BUNDLED_ENV: Record<string, string | undefined> = {
  RAINDROP_API_KEY: process.env.RAINDROP_API_KEY,
  DEVIN_API_KEY: process.env.DEVIN_API_KEY,
  DEVIN_ORG_ID: process.env.DEVIN_ORG_ID,
  PERPLEXITY_API_KEY: process.env.PERPLEXITY_API_KEY,
  OPENAI_API_KEY: process.env.OPENAI_API_KEY,
  GEMINI_API_KEY: process.env.GEMINI_API_KEY,
};

/**
 * Resolve a bundled environment variable by name.
 * Returns the build-time value if baked in, otherwise falls back to
 * the runtime `process.env` lookup (useful in dev mode).
 */
export function getBundledEnv(varName: string): string | undefined {
  return BUNDLED_ENV[varName] ?? process.env[varName];
}
